import type { AudiHeaderStateServiceInterfaceV2 } from '@oneaudi/header-state-service';
import type { ActiveItem } from '../reducers/header-reducer';

export enum HeaderActionTypes {
  SetActiveItem = 'SET_ACTIVE_ITEM',
  LoadSearchFA = 'LOAD_SEARCH_FA',
}

interface ActiveItemAction {
  type: HeaderActionTypes;
  payload: {
    activeItem: ActiveItem;
  };
}

export type IHeaderAction = ActiveItemAction;

export const createPreloadAction: () => {
  payload: { activeItem: null };
  type: HeaderActionTypes;
} = () => {
  return {
    payload: { activeItem: null },
    type: HeaderActionTypes.LoadSearchFA,
  };
};

export const createSetActiveItemAction: ({
  anchor,
  index,
  showSearch,
  headerStateService,
}: {
  anchor: HTMLAnchorElement | null;
  index: number;
  showSearch: boolean;
  showDealer: boolean;
  showLoginFlyout: boolean;
  showWistListFlyout: boolean;
  headerStateService: AudiHeaderStateServiceInterfaceV2;
}) => ActiveItemAction = ({
  anchor,
  index,
  showSearch,
  headerStateService,
  showDealer,
  showLoginFlyout,
  showWistListFlyout,
}) => {
  headerStateService.setShowSearch(showSearch);
  headerStateService.setShowDealer(showDealer);
  headerStateService.setShowLoginFlyout(showLoginFlyout);
  headerStateService.setShowWistListFlyout(showWistListFlyout);

  if (!showSearch && index !== -1) {
    headerStateService.setShowLoginFlyout(false);
    headerStateService.setShowWistListFlyout(false);
  }

  return {
    payload: {
      activeItem: {
        anchor,
        index,
        showSearch,
        showDealer,
        showLoginFlyout,
        showWistListFlyout,
      },
    },
    type: HeaderActionTypes.SetActiveItem,
  };
};

export const createResetActiveItemAction: (
  headerStateService: AudiHeaderStateServiceInterfaceV2,
) => ActiveItemAction = (headerStateService) => {
  return createSetActiveItemAction({
    anchor: null,
    headerStateService,
    index: -1,
    showSearch: false,
    showDealer: false,
    showLoginFlyout: false,
    showWistListFlyout: false,
  });
};
